import PolicyEmitted from './PolicyEmitted'

export default PolicyEmitted
